import script from "./Excursions.vue?vue&type=script&setup=true&lang=ts"
export * from "./Excursions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__